'use strict';
module.exports = require('../../full/instance/filter');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/instance/filter.js
// module id = 594
// module chunks = 13